// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoPositionSelector_RDlK4 {
  margin-top: 20px;
  min-height: auto; 
}

.label_Net9E {
  display: block;
  font-size: 1rem;
  color: var(--black-color);
  font-weight: 500;
  margin-bottom: 12px;
  text-align: left;
}

.grid_eOsz9 {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px 0 8px 0;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.grid_eOsz9::-webkit-scrollbar {
  display: none;
}

.grid_eOsz9 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.positionItem_OhCZH:nth-child(1),
.positionItem_OhCZH:nth-child(2) {
  width: 40%;
}
.positionItem_OhCZH:nth-child(3),
.positionItem_OhCZH:nth-child(4),
.positionItem_OhCZH:nth-child(5) {
  width: 30%;
}

.positionItem_OhCZH:last-child {
  width: 40%;
}

.positionItem_OhCZH {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 10px 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  text-align: center;
  background-color: var(--white-background);
  display: flex;
  gap: 10px;
  align-items: center;
  min-height: 70px;
  width: 180px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.positionItem_OhCZH:hover {
  border-color: #b6b6b6;
}

.positionItem_OhCZH.selected_YMZFC {
  border-color: transparent;
  background-color: var(--f5-background);
}

.positionIcon_xxAfh {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
}

.positionName_HjHJ2 {
  font-size: 0.85rem;
  color: #555;
  display: block;
  line-height: 1.2;
  flex: 1 1;
}


@media (max-width: 1024px) {
  .logoPositionSelector_RDlK4 {
    margin-top: 18px;
  }

  .label_Net9E {
    font-size: 0.95rem;
    margin-bottom: 10px;
  }

  .grid_eOsz9 {
    gap: 10px;
    padding: 4px 0 6px 0;
    overflow-x: auto;
  }

  .positionItem_OhCZH {
    padding: 9px 7px;
    gap: 9px;
    min-height: 65px;
    width: 170px;
    flex-shrink: 0;
  }

  .positionIcon_xxAfh {
    width: 32px;
    height: 32px;
  }

  .positionName_HjHJ2 {
    font-size: 0.8rem;
    line-height: 1.15;
  }
}

@media (max-width: 768px) {
  .logoPositionSelector_RDlK4 {
    margin-top: 16px;
  }

  .label_Net9E {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }

  .grid_eOsz9 {
    gap: 10px;
    padding: 4px 0 6px 0;
  }

  .positionItem_OhCZH {
    padding: 8px 6px;
    gap: 8px;
    min-height: 60px;
    width: 160px;
  }

  .positionIcon_xxAfh {
    width: 28px;
    height: 28px;
  }

  .positionName_HjHJ2 {
    font-size: 0.75rem;
    line-height: 1.1;
  }
}

@media (max-width: 480px) {
  .logoPositionSelector_RDlK4 {
    margin-top: 12px;
  }

  .label_Net9E {
    font-size: 0.85rem;
    margin-bottom: 8px;
  }

  .grid_eOsz9 {
    gap: 8px;
  }

  .positionItem_OhCZH {
    padding: 6px 4px;
    gap: 6px;
    min-height: 50px;
    width: 140px;
    flex-direction: row;
    text-align: left;
  }

  .positionIcon_xxAfh {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .positionName_HjHJ2 {
    font-size: 0.65rem;
    line-height: 1.0;
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/LogoPositionSelector/LogoPositionSelector.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,wDAAwD;EACxD,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;;AAGA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;EACT;AACF","sourcesContent":[".logoPositionSelector {\n  margin-top: 20px;\n  min-height: auto; \n}\n\n.label {\n  display: block;\n  font-size: 1rem;\n  color: var(--black-color);\n  font-weight: 500;\n  margin-bottom: 12px;\n  text-align: left;\n}\n\n.grid {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 4px 0 8px 0;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n\n.grid::-webkit-scrollbar {\n  display: none;\n}\n\n.grid {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.positionItem:nth-child(1),\n.positionItem:nth-child(2) {\n  width: 40%;\n}\n.positionItem:nth-child(3),\n.positionItem:nth-child(4),\n.positionItem:nth-child(5) {\n  width: 30%;\n}\n\n.positionItem:last-child {\n  width: 40%;\n}\n\n.positionItem {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  padding: 10px 8px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  text-align: center;\n  background-color: var(--white-background);\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  min-height: 70px;\n  width: 180px;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.positionItem:hover {\n  border-color: #b6b6b6;\n}\n\n.positionItem.selected {\n  border-color: transparent;\n  background-color: var(--f5-background);\n}\n\n.positionIcon {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.positionName {\n  font-size: 0.85rem;\n  color: #555;\n  display: block;\n  line-height: 1.2;\n  flex: 1;\n}\n\n\n@media (max-width: 1024px) {\n  .logoPositionSelector {\n    margin-top: 18px;\n  }\n\n  .label {\n    font-size: 0.95rem;\n    margin-bottom: 10px;\n  }\n\n  .grid {\n    gap: 10px;\n    padding: 4px 0 6px 0;\n    overflow-x: auto;\n  }\n\n  .positionItem {\n    padding: 9px 7px;\n    gap: 9px;\n    min-height: 65px;\n    width: 170px;\n    flex-shrink: 0;\n  }\n\n  .positionIcon {\n    width: 32px;\n    height: 32px;\n  }\n\n  .positionName {\n    font-size: 0.8rem;\n    line-height: 1.15;\n  }\n}\n\n@media (max-width: 768px) {\n  .logoPositionSelector {\n    margin-top: 16px;\n  }\n\n  .label {\n    font-size: 0.9rem;\n    margin-bottom: 10px;\n  }\n\n  .grid {\n    gap: 10px;\n    padding: 4px 0 6px 0;\n  }\n\n  .positionItem {\n    padding: 8px 6px;\n    gap: 8px;\n    min-height: 60px;\n    width: 160px;\n  }\n\n  .positionIcon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .positionName {\n    font-size: 0.75rem;\n    line-height: 1.1;\n  }\n}\n\n@media (max-width: 480px) {\n  .logoPositionSelector {\n    margin-top: 12px;\n  }\n\n  .label {\n    font-size: 0.85rem;\n    margin-bottom: 8px;\n  }\n\n  .grid {\n    gap: 8px;\n  }\n\n  .positionItem {\n    padding: 6px 4px;\n    gap: 6px;\n    min-height: 50px;\n    width: 140px;\n    flex-direction: row;\n    text-align: left;\n  }\n\n  .positionIcon {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n  }\n\n  .positionName {\n    font-size: 0.65rem;\n    line-height: 1.0;\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoPositionSelector": `logoPositionSelector_RDlK4`,
	"label": `label_Net9E`,
	"grid": `grid_eOsz9`,
	"positionItem": `positionItem_OhCZH`,
	"selected": `selected_YMZFC`,
	"positionIcon": `positionIcon_xxAfh`,
	"positionName": `positionName_HjHJ2`
};
export default ___CSS_LOADER_EXPORT___;
